import '../ods/components/typeahead-dropdown/typeahead-dropdown';
import '../ods/components/modal/modal';
import '@upmc-healthplan-npm/ods-wc';
import { ActiveToast, ToastrModule, ToastrService, provideToastr } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Injector } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ENVIRONMENT, HELIOS_SSO, LAUNCH_DARKLY, LEGACY_SSO } from './tokens';
import { NgIdleModule } from '@ng-idle/core';
import { NavigationEnd, Router } from '@angular/router';
import { POLCoreModule } from './core/core.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { resolveEnvironment, resolveHeliosSso, resolveLaunchDarkly, resolveLegacySso } from './environment-resolver';
import { SharedModule } from './shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { UnauthorizedErrorComponent } from './core/pages/unauthorized-error/unauthorized-error.component';

@NgModule({
  declarations: [AppComponent, UnauthorizedErrorComponent],
  imports: [
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 50 // Retains last 25 states
    }),
    AppRoutingModule,
    POLCoreModule.forRoot(),
    SharedModule,
    BrowserAnimationsModule,
    NgIdleModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ToastrModule.forRoot()
  ],
  providers: [
    { provide: ENVIRONMENT, useFactory: resolveEnvironment },
    { provide: HELIOS_SSO, useFactory: resolveHeliosSso },
    { provide: LEGACY_SSO, useFactory: resolveLegacySso },
    { provide: LAUNCH_DARKLY, useFactory: resolveLaunchDarkly },
    provideToastr({
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true
    }),
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  static injector: Injector;
  static toasts: ActiveToast<any>[] = [];
  previousUrl: string;

  constructor(injector: Injector, router: Router) {
    AppModule.injector = injector;
    // remove each toast when navigating between pages
    router.events.subscribe(res => {
      if (res instanceof NavigationEnd) {
        if (res.urlAfterRedirects !== this.previousUrl) {
          const toastr = injector.get(ToastrService);

          for (const toast of AppModule.toasts) {
            toastr.remove(toast.toastId);
          }
        }

        this.previousUrl = res.urlAfterRedirects;
      }
    });
  }
}
